import { createRootRoute, Outlet } from '@tanstack/react-router';
import type { CSSProperties } from 'react';
import { NotFound } from '../components/NotFound.js';
import { SiteFooter, SiteHeader } from '../components/SiteChrome.js';
import { SiteGate } from '../components/SiteGate.js';
import { brand, environment, region } from '../lib/env.js';

export const Route = createRootRoute({
  component: RootLayout,
  notFoundComponent: NotFound,
});

const brandStyles: CSSProperties & Record<`--${string}`, string> = {
  '--brand-primary': brand.colors.primary[500],
  '--brand-primary-foreground': brand.colors.primaryForeground,
  '--brand-primary-strong': brand.colors.primary[700],
  '--brand-primary-strong-foreground': brand.colors.primaryStrongForeground,
  '--brand-primary-soft': brand.colors.primary[100],
  '--brand-progress': brand.colors.progress,
  '--brand-header': brand.colors.headerBg,
  '--brand-footer': brand.colors.footerBg,
  '--brand-page': brand.colors.plannerPageBg,
  '--brand-ink': brand.colors.text,
  '--brand-font-heading': brand.fonts.heading,
  '--brand-font-body': brand.fonts.body,
};

function RootLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-page font-body text-ink" style={brandStyles}>
      <SiteHeader />
      <SiteGate regionCode={region.code} environment={environment}>
        <Outlet />
      </SiteGate>
      <SiteFooter />
    </div>
  );
}
